import React from 'react';

const pillars = [
  {
    icon: '✦',
    title: 'Cuidado',
    desc: 'Cada detalhe da sua sessão é pensado para que se sinta acolhida, confortável e bem tratada do início ao fim.',
  },
  {
    icon: '◈',
    title: 'Privacidade',
    desc: 'O seu atendimento é realizado num ambiente reservado e discreto, onde a sua privacidade é sempre respeitada.',
  },
  {
    icon: '◇',
    title: 'Profissionalismo',
    desc: 'Técnicas especializadas, materiais de qualidade e um atendimento que respeita o seu tempo e o seu corpo.',
  },
  {
    icon: '○',
    title: 'Conforto',
    desc: 'Um espaço pensado para que se sinta em casa — tranquila, segura e completamente à vontade.',
  },
];

export default function WhyChooseSection() {
  return (
    <section className="py-24 lg:py-32" style={{ background: '#FFD6E0' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="gold-line mx-auto mb-6 block" />
          <p className="text-xs tracking-[0.25em] uppercase font-medium text-burnt-rose mb-4">
            Porquê Escolher-nos
          </p>
          <h2 className="font-serif text-4xl lg:text-5xl font-light leading-[1.1] text-dark-brown">
            A diferença que<br />
            <em className="italic text-burnt-rose">sente na pele.</em>
          </h2>
        </div>

        {/* Asymmetric bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {pillars?.map((pillar, i) => (
            <div
              key={pillar?.title}
              className={`relative p-8 rounded-2xl border border-border/60 bg-white overflow-hidden group hover:border-burnt-rose/30 transition-all duration-300 hover:shadow-lg ${
                i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              {/* Background accent */}
              <div className="absolute top-0 right-0 w-24 h-24 rounded-full bg-blush/50 -translate-y-1/2 translate-x-1/2 group-hover:bg-dusty-rose/30 transition-colors duration-300" />

              <div className="relative">
                <span className="text-2xl text-burnt-rose/40 mb-4 block font-serif">{pillar?.icon}</span>
                <h3 className="font-serif text-2xl lg:text-3xl font-light text-dark-brown mb-3">{pillar?.title}</h3>
                <p className="text-sm text-foreground/60 leading-relaxed">{pillar?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
